import { render, staticRenderFns } from "./EditCase.vue?vue&type=template&id=4fcb70f2&scoped=true"
import script from "./EditCase.vue?vue&type=script&lang=js"
export * from "./EditCase.vue?vue&type=script&lang=js"
import style0 from "./EditCase.vue?vue&type=style&index=0&id=4fcb70f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fcb70f2",
  null
  
)

export default component.exports